<template>
  <div class="row">
    <div class="container-fluid">
      <div class="row server-list">
        <div class="col-md-12">
          <p class="text-center">
            <button type="button" class="btn btn-lg btn-success btn-fill" v-b-modal.add-license-modal>
              <span class="btn-label">
                <i class="fa fa-plus"></i>
              </span>
              Add new license
            </button>
          </p>
          <b-modal id="add-license-modal" title="Add New WebGrab+ License" no-fade hide-footer>
            <form @submit.prevent="submitLicenseCreate">
              <div class="form-group">
                <label>License Username</label>
                <input type="text" placeholder="Enter username" class="form-control" v-model="forms.licenseCreate.username">
              </div>
              <div class="form-group">
                <label>License Email</label>
                <input type="email" placeholder="Enter email" class="form-control" v-model="forms.licenseCreate.email">
              </div>
              <div class="form-group">
                <label>License Code</label>
                <input type="text" placeholder="Enter License Code" class="form-control" v-model="forms.licenseCreate.password">
              </div>
              <button type="submit" class="btn btn-fill btn-info">Submit</button>
            </form>
          </b-modal>
        </div>
      </div>
      <div class="row server-list">
        <license-card v-for="license in licensesAll" :key="license.id" :license="license"/>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import LicenseCard from "./List/LicenseCard";

export default {
  components: {LicenseCard},
  mounted () {
    this.licenseFetchList();
    this.serverFetchList();
  },
  data: function () {
    return {
      forms: {
        licenseCreate: {
          email: '',
          password: ''
        }
      },
      servers: [
        {}
      ]
    }
  },
  computed: mapGetters(['licensesAll']),
  methods: {
    ...mapActions(['licenseCreate', 'licenseFetchList', 'serverFetchList']),
    submitLicenseCreate: function () {
      this.licenseCreate(this.forms.licenseCreate);
      this.$bvModal.hide('add-license-modal');
    }
  }
}
</script>
<style>
.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}

.server-list {
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Licenses/List.vue